import * as React from 'react';
import { StatusCard } from './StatusCard';
import { Spinner, Timeline } from '@/components/common';
import { CaseOverviewModal } from '@/components/modals';
import { CaseApplications, ClientApproveStatus } from '@/interfaces';
import useModal from '@/hooks/useModal';
import { useCaseSteps } from '@/hooks/queries/useCaseSteps';
import { useTogglePinCase } from '@/hooks/useTogglePinCase';
import { HIDE_PIN_STATUSES_CASE } from '@/const/cases';
import { isCaseTimelineDisabled } from '@/utils/caseStatus';
import { useRouter } from 'next/router';
import { CardContainer } from '../containers';

interface StatusDetailsProps {
	caseApplications?: CaseApplications;
	refetchCase: () => void;
	clientApproveStatus?: ClientApproveStatus;
}

export const StatusDetails: React.FC<StatusDetailsProps> = ({
	caseApplications,
	refetchCase,
	clientApproveStatus,
}) => {
	const router = useRouter();
	const {
		Modal: ModalConfirmAccount,
		show: showConfirmAccount,
		hide: hideConfirmAccount,
	} = useModal();

	const { data: steps } = useCaseSteps(caseApplications?.id);
	const { togglePinCase } = useTogglePinCase(refetchCase);

	return (
		<>
			{caseApplications ? (
				<StatusCard
					step_name={caseApplications.step_name}
					clientApproveEmail={
						!clientApproveStatus?.isApproved && clientApproveStatus?.emailSent
					}
					id={caseApplications.id}
					status={caseApplications.progress_status}
					isPinned={caseApplications.is_pinned}
					showPin={
						router.pathname.includes('client-profile')
							? false
							: !HIDE_PIN_STATUSES_CASE.includes(
									caseApplications.progress_status
							  )
					}
					textSize="bold-22"
					title={caseApplications.title}
					category={caseApplications.category_name}
					onClickOverview={
						router.pathname.includes('client-profile')
							? undefined
							: showConfirmAccount
					}
					earned={caseApplications.earned}
					onClickPin={() => togglePinCase(caseApplications.id)}
					classNameTitle="!text-[22px]"
				>
					<div className="overflow-x-auto scroll-custom">
						<div className="min-w-[1130px]">
							{steps && steps.data.length > 0 && (
								<Timeline
									options={steps.data.map((step) => step.name)}
									totalSteps={caseApplications.total_steps}
									defaultValue={caseApplications.numerical_order}
									disabled={isCaseTimelineDisabled(
										caseApplications,
										clientApproveStatus
									)}
								/>
							)}
						</div>
					</div>
				</StatusCard>
			) : (
				<CardContainer title="" icon="">
					<div className="flex justify-center items-center w-full h-full">
						<Spinner type="loadingPage" />
					</div>
				</CardContainer>
			)}
			{caseApplications && (
				<ModalConfirmAccount classNameContainerChildren="!max-h-full lg:!max-h-[80vh]">
					<CaseOverviewModal
						caseApplications={caseApplications}
						hideConfirmAccount={hideConfirmAccount}
					/>
				</ModalConfirmAccount>
			)}
		</>
	);
};
